__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "lumen";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.9.11", () => (() => (__webpack_require__(643871))), 1);
			register("@hawkins-community/graphql-client", "9.0.3", () => (Promise.all([__webpack_require__.e(99412), __webpack_require__.e(96588), __webpack_require__.e(63486), __webpack_require__.e(34155)]).then(() => (() => (__webpack_require__(599412))))));
			register("@hawkins-community/user-authentication", "7.0.33", () => (__webpack_require__.e(47095).then(() => (() => (__webpack_require__(947095))))));
			register("@netflix/nfa-logger", "2.6.0", () => (() => (__webpack_require__(253845))), 1);
			register("jotai", "2.19.1", () => (() => (__webpack_require__(813665))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(973935))), 1);
			register("react-router-dom", "6.4.2", () => (() => (__webpack_require__(949818))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(667294))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};